import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { Dimmer } from 'semantic-ui-react';
import { pageDataHandlers, pageDataInitialState, pageDataReducer } from '../reducers/PageDataReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { usePageData } from './useHelpers/usePageData';
import { useRenders } from './useHelpers/useRenders';

export const PageDataContext = createContext();

/**
 * 
 * @param {object} props 
 * @returns 
 */
const PageDataProvider = (props) => {

  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { currentSettings_state, appSettings_state, eventInfo_state, googleData_state, paps_state, page_state } = states ?? {}
  const { page_handlers, startData_handlers } = handlers ?? {}

  useRenders('PageDataProvider', true, true)

  const { getPageData } = usePageData()

  // authContext 
  const appUserAccess = useAppUserAccess()

  const { dataOverrideOn } = appSettings_state ?? {}

  // papsContext 
  const { pathName, view, viewKey } = paps_state ?? {}

  // pageContext 
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { menu: menu_page, viewItems: viewItems_page } = aps_page ?? {}
  const { captionProps, caption: caption_page, subCaptionProps } = menu_page ?? {}

  let viewItem_page = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  const { dataSource, dataConstraints } = viewItem_page ?? {}

  const _dataConstraints = dataConstraints ? dataConstraints : dataSource

  const { appDataDocuments, staticViews } = eventInfo_state ?? {}
  const { googleDataOn } = googleData_state ?? {}

  // IMPORTANT: Page Data - Get the data state
  const init_state = { pathName, captionProps, subCaptionProps, caption_page, appDataDocuments, staticViews }
  const [pageData_state, pageData_dispatch] = useReducer(pageDataReducer, pageDataInitialState(init_state));

  const pageData_handlers = useMemo(
    () => pageDataHandlers(pageData_dispatch),
    [pageData_dispatch]
  );

  const { pageDataRetrieved, currentPageDataCaption, currentPageDataSubCaption, pageDataKey, currentPageData } = pageData_state ?? {}

  useEffect(() => {

    const pdProps = {
      appDataDocuments,
      appUserAccess,
      currentSettings_state,
      dataOverrideOn,
      googleData_state,
      isPageData: true,
      page_state,
      pageData_state,
      paps_state,
      staticViews,
      view,
      viewKey,
      pageData_state,
    }

    getPageData({ pageDataProps: pdProps, callback: pageData_handlers.handleSetPageData })

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pathName, _dataConstraints, googleDataOn]);

  useEffect(() => {
    if (currentPageDataCaption && page_handlers) {
      page_handlers.handleUpdatePageDataCaption(currentPageDataCaption, currentPageDataSubCaption)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentPageDataCaption, currentPageDataSubCaption]);

  useEffect(() => {
    if (pageDataKey && currentPageData) {
      startData_handlers.handlePageData(pageDataKey, currentPageData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pageDataKey]);

  return pageDataRetrieved ? <PageDataContext.Provider value={{ pageData_handlers, pageData_state }}>
    {props.children}
  </PageDataContext.Provider>
    :
    <Dimmer active={true}><div className={'pending-wait'}></div>{''}</Dimmer>
}

export default PageDataProvider